export const TEST_ID = 'homePageTopBar';
